import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useT } from '../context/LanguageContext';
import { useData } from '../context/DataContext';
import { carsysApi } from '../api/carsysApi';
import InvoiceDocument from './InvoiceDocument';

export default function PrintFactuur({ bon, klant, gegevens, onClose }) {
  const { t } = useT();
  const { user } = useAuth();
  const { klantAutos } = useData();
  const layout = gegevens?.bonLayout || {};
  const [logoUrl, setLogoUrl] = useState(null);

  // Voertuig matchen op kenteken (merk/model/bouwjaar/VIN/APK voor het voertuigblok)
  const voertuig = (bon?.kenteken && (klantAutos || []).find(
    a => (a.kenteken || '').replace(/[-\s]/g, '').toUpperCase() === bon.kenteken.replace(/[-\s]/g, '').toUpperCase()
  )) || null;

  const print = () => {
    const node = document.getElementById('print-content');
    if (!node) { window.print(); return; }
    const w = window.open('', '_blank', 'width=900,height=1200');
    if (!w) { alert('Sta pop-ups toe om af te drukken / pdf te maken.'); return; }
    w.document.open();
    w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${bon?.nummer || 'Bon'}</title>
      <style>
        body { font-family: ui-sans-serif, system-ui, -apple-system, sans-serif; color: #0f172a; margin: 0; padding: 18mm; }
        table { border-collapse: collapse; }
        @page { size: A4; margin: 0; }
      </style>
    </head><body>${node.innerHTML}</body></html>`);
    w.document.close();
    w.focus();
    const doPrint = () => { try { w.print(); } catch { /* noop */ } };
    if (w.document.images.length === 0) {
      setTimeout(doPrint, 200);
    } else {
      let loaded = 0; const total = w.document.images.length;
      Array.from(w.document.images).forEach(img => {
        if (img.complete) { loaded++; if (loaded === total) doPrint(); }
        else { img.onload = img.onerror = () => { loaded++; if (loaded === total) doPrint(); }; }
      });
      setTimeout(doPrint, 1500);
    }
  };

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  // Logo met JWT ophalen en als blob-URL renderen
  useEffect(() => {
    if (!gegevens?.logoPath || !user?.garageId) return;
    let cancelled = false;
    const tok = localStorage.getItem('monteurcentraal_token');
    fetch(carsysApi.logoUrl(user.garageId), { headers: { Authorization: `Bearer ${tok}` } })
      .then(r => r.ok ? r.blob() : Promise.reject(r.status))
      .then(b => { if (!cancelled) setLogoUrl(URL.createObjectURL(b)); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [gegevens?.logoPath, user?.garageId]);

  return (
    <div className="print-overlay">
      <div className="print-controls no-print">
        <button className="cs-btn" onClick={onClose}>{t('Sluiten')} (Esc)</button>
        <button className="cs-btn primary" onClick={print}>{t('Afdrukken / Opslaan als PDF', 'Afdrukken / Opslaan als PDF')}</button>
      </div>
      <div className="print-page" id="print-content">
        <InvoiceDocument bon={bon} klant={klant} voertuig={voertuig} gegevens={gegevens} layout={layout} logoUrl={logoUrl} t={t} />
      </div>

      <style>{`
        .print-overlay { position: fixed; inset: 0; background: rgba(15,23,42,0.85); z-index: 200; overflow: auto; padding: 30px; }
        .print-controls { position: fixed; top: 20px; right: 30px; display: flex; gap: 8px; z-index: 210; }
        .print-page { background: #fff; max-width: 820px; margin: 0 auto; padding: 48px 52px; box-shadow: 0 8px 40px rgba(0,0,0,0.4); }
        @media print {
          body * { visibility: hidden; }
          .print-overlay, .print-overlay * { visibility: visible; }
          .print-overlay { position: static; padding: 0; background: white; }
          .no-print { display: none !important; }
          .print-page { box-shadow: none; max-width: none; padding: 18mm; }
          @page { size: A4; margin: 0; }
        }
      `}</style>
    </div>
  );
}
